import Vue from "vue";
import Vuex from "vuex";

import router from "@/router";

import {
	Message
} from "element-ui";


import createPersistedState from "vuex-persistedstate";


import ajax from "@/utils/request.js"; //导入 axios 配置
const api = ajax.api; //请求方法

// debugger
console.log("========== ajax ==========", ajax);

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		router_list: [], //顶部路由
		vuex_setting:{},
		vuex_bom_show:true,
		vuex_sf_type:'',//身份:1普通用户,2律师-执业,3律师-非执业,4法律专家,5法律资格从业者,6工商企业,7律所
		vuex_is_law_firm_apply:0,//0可以申请 1不可以
		vuex_user: {}, //用户信息
		vuex_new_list:[],//推荐新闻
		vuex_new_list2:[],//推荐新闻
		vuex_case_list:[],//推荐案例
		vuex_type_list:[],//选择项
		vuex_region_list:[],//地区列表
		vuex_lawyers:[],//推荐律师
		vux_case_type:[],//案件类型
		vux_case_type2:[],//案源
		vuex_form_list:[
			{
				show_num:'1',//
				title:'查明事实',
				out_show:true,//是否必填 是否显示*
				form_text:'cmss',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入查明事实',
			},
			{
				show_num:'1',//
				title:'法院认定',
				out_show:true,//是否必填 是否显示*
				form_text:'fyrd',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法院认定',
			},
			{ 
				show_num:'1',//
				title:'法律适用',
				out_show:true,//是否必填 是否显示*
				form_text:'flsy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律适用',
			},
			{
				show_num:'1',//
				title:' 法律判决',
				out_show:true,//是否必填 是否显示*
				form_text:'fypj',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律判决',
			},

			 {
				show_num:'1',//
				title:' 法律建议',
				out_show:true,//是否必填 是否显示*
				form_text:'fljy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律建议',
			},
			{
				show_num:'2',//
				title:'法院调查',
				out_show:true,//是否必填 是否显示*
				form_text:'ftdc',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法院调查',
			},
			{
				show_num:'2',//
				title:'证据质证',
				out_show:true,//是否必填 是否显示*
				form_text:'zjzz',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入证据质证',
			},
			{
				show_num:'2',//
				title:'法院辩论',
				out_show:true,//是否必填 是否显示*
				form_text:'fybl',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法院辩论',
			},
			{
				show_num:'2',//
				title:'查明事实',
				out_show:true,//是否必填 是否显示*
				form_text:'cmss',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入查明事实',
			},
			{
				show_num:'2',//
				title:'法院认定',
				out_show:true,//是否必填 是否显示*
				form_text:'fyrd',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法院认定',
			},
			{
				show_num:'2',//
				title:'法律适用',
				out_show:true,//是否必填 是否显示*
				form_text:'flsy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律适用',
			},
			{
				show_num:'2',//
				title:'法律建议',
				out_show:true,//是否必填 是否显示*
				form_text:'fljy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律建议',
			},


			{
				show_num:'3',//
				title:'法庭调查',
				out_show:true,//是否必填 是否显示*
				form_text:'ftdc',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法庭调查',
			},
			{
				show_num:'3',//
				title:'证据质证',
				out_show:true,//是否必填 是否显示*
				form_text:'zjzz',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入证据质证',
			},
			{
				show_num:'3',//
				title:'庭审笔录',
				out_show:true,//是否必填 是否显示*
				form_text:'tsbl',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入庭审笔录',
			},
			{
				show_num:'3',//
				title:'法院辩论',
				out_show:true,//是否必填 是否显示*
				form_text:'fybl',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法院辩论',
			},
			{
				show_num:'3',//
				title:'查明事实',
				out_show:true,//是否必填 是否显示*
				form_text:'cmss',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入查明事实',
			},
			{
				show_num:'3',//
				title:'法院认定',
				out_show:true,//是否必填 是否显示*
				form_text:'fyrd',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法院认定',
			},
			{
				show_num:'3',//
				title:' 法律适用',
				out_show:true,//是否必填 是否显示*
				form_text:'flsy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律适用',
			},
			{
				show_num:'3',//
				title:' 类案比较',
				out_show:true,//是否必填 是否显示*
				form_text:'labj',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入类案比较',
			},
			{
				show_num:'3',//
				title:'法官裁量空间',
				out_show:true,//是否必填 是否显示*
				form_text:'fgclkj',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法官裁量空间',
			},
			{
				show_num:'3',//
				title:'法律建议',
				out_show:true,//是否必填 是否显示*
				form_text:'fljy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律建议',
			},


			

			{
				show_num:'4',//
				title:'法庭调查',
				out_show:true,//是否必填 是否显示*
				form_text:'ftdc',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法庭调查',
			},
			{
				show_num:'4',//
				title:'证据质证',
				out_show:true,//是否必填 是否显示*
				form_text:'zjzz',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入证据质证',
			},
			{
				show_num:'4',//
				title:'庭审笔录',
				out_show:true,//是否必填 是否显示*
				form_text:'tsbl',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入庭审笔录',
			},
			{
				show_num:'4',//
				title:'法院辩论',
				out_show:true,//是否必填 是否显示*
				form_text:'fybl',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法法院辩论',
			},
			{
				show_num:'4',//
				title:'查明事实',
				out_show:true,//是否必填 是否显示*
				form_text:'cmss',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入查明事实',
			},
			{
				show_num:'4',//
				title:'法院认定',
				out_show:true,//是否必填 是否显示*
				form_text:'fyrd',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法院认定',
			},
			{
				show_num:'4',//
				title:' 法律适用',
				out_show:true,//是否必填 是否显示*
				form_text:'flsy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律适用',
			},
			{
				show_num:'4',//
				title:' 类案比较',
				out_show:true,//是否必填 是否显示*
				form_text:'labj',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入类案比较',
			},
			{
				show_num:'4',//
				title:'法官裁量空间',
				out_show:true,//是否必填 是否显示*
				form_text:'fgclkj',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法官裁量空间',
			},
			{
				show_num:'4',//
				title:'法律建议',
				out_show:true,//是否必填 是否显示*
				form_text:'fljy',//提交的字段
				form_val:'',//提交的值
				placeholder_text:'请输入法律建议',
			},
		],
		vuex_custom_type_list:[
			{
				title:'自然人',
				value:1,
			},
			{
				title:'法人',
				value:2,
			},
			{
				title:'其它组织',
				value:3,
			},
			
		],
		uex_SensitiveWord:[],
	},

	getters: {},

	mutations: {
		//登录储存用户信息
		set_vuex_user(state, data) {
			localStorage.setItem('cache_user', JSON.stringify(data))
			state.vuex_user = data
		},
		//退出登录删除用户信息
		clear_vuex_user(state, data) {
			state.vuex_user = {}
			localStorage.removeItem('token')
			localStorage.removeItem('last_activity_time')
			sessionStorage.removeItem('session_active')
			router.push({
				path:'/login'
			})
		},
		 set_vuex_setting(state,data){
			state.vuex_setting=data
		 },
		 get_vuex_bom_show(state,data){
			state.vuex_bom_show=data
		 },
		 get_vuex_region_list(state,data){
			state.vuex_region_list=data
		 },
		 
		 get_vuex_sf_type(state,data){
			state.vuex_sf_type=data
		 },
		 get_vuex_is_law_firm_apply(state,data){
			state.vuex_is_law_firm_apply=data
		 },
		 set_vuex_lawyers(state,data){
			state.vuex_lawyers=data

		 },
		 set_vux_case_type(state,data){
			state.vux_case_type=data

		 },
		 set_vuex_new_list(state,data){
			state.vuex_new_list=data

		 },
		 set_vuex_new_list2(state,data){
			state.vuex_new_list2=data

		 },
		 
		 set_vuex_case_list(state,data){
			state.vuex_case_list=data

		 },
		 set_vux_case_type2(state,data){
			state.vux_case_type2=data

		 },
		 set_vuex_SensitiveWord(state,data){
			state.uex_SensitiveWord=data

		 },
		 
	},
	actions: {
		//初始化查询
		appInit({
			commit,
			dispatch,
			state
		}, data) {
			dispatch('get_type_setting')
			dispatch('get_region_list')
			dispatch('get_vux_lawyers')
			dispatch('get_vux_case_type')
			dispatch('get_vux_case_type2')
			dispatch('get_vuex_new_list')
			dispatch('get_vuex_new_list2')
			dispatch('get_vuex_case_list')
			dispatch('get_SensitiveWord')
			
			

			
			
			let token = localStorage.getItem('token')
			// if (!token) {
			// 	return
			// }
			dispatch('query_user')
			
		},
		//查询用户信息
		query_user({
			commit,
			dispatch,
			state
		}, data) {
			api('getUserInfo', {
				is_logo:1,
			}, "get").then((res) => {
				console.log('用户信息',res)
				if (res.code == 1) {
					// commit('set_vuex_setting', res.data)
					commit('get_vuex_sf_type', res.data.type)
					if(res.data.log_type==1){
						commit('get_vuex_is_law_firm_apply', res.data.is_law_firm_apply)
					}else{
						commit('get_vuex_is_law_firm_apply', 1)
					}
					commit('set_vuex_user', res.data)
				}
			})
		},
		get_vux_lawyers({
			commit,
			dispatch,
			state
		}, data){
			api('lawyers', {
				limit:10,
				recommend:1,
			}, "get").then((res) => {
				console.log('推荐律师',res)
				if (res.code == 1) {
					commit('set_vuex_lawyers', res.data.data)
					 
				}
			})
		},
		get_vux_case_type({
			commit,
			dispatch,
			state
		}, data){
			api('tags', {
				type:1,

			}, "get").then((res) => {
				console.log('案件类型',res)
				if (res.code == 1) {
					commit('set_vux_case_type', res.data)
					 
				}
			})
		},
 
	 
		get_vuex_new_list({
			commit,
			dispatch,
			state
		}, data){
			api('getArticleList', {
				 
			}, "get").then((res) => {
				console.log('新闻列表',res)
				if (res.code == 1) {
					commit('set_vuex_new_list', res.data.list)
					 
				}
			})
		},
		get_vuex_new_list2({
			commit,
			dispatch,
			state
		}, data){
			api('getArticleList', {
				category_id:28,
			}, "get").then((res) => {
				console.log('新闻列表',res)
				if (res.code == 1) {
					commit('set_vuex_new_list2', res.data.list)
					 
				}
			})
		},
		get_vuex_case_list({
			commit,
			dispatch,
			state
		}, data){
			api('caseList', {
				anliku:1,
			}, "get").then((res) => {
				console.log('案例推荐列表',res)
				if (res.code == 1) {
					commit('set_vuex_case_list', res.data.data)
					 
				}
			})
		},
		get_SensitiveWord({
			commit,
			dispatch,
			state
		}, data){
			api('getSensitiveWord', {
				 
			}, "get").then((res) => {
				console.log('敏感词语',res)
				if (res.code == 1) {
					commit('set_vuex_SensitiveWord', res.data)
					 
				}
			})
		},

		get_vux_case_type2({
			commit,
			dispatch,
			state
		}, data){
			api('cause', {
				 
			}, "get").then((res) => {
				console.log('案源',res)
				if (res.code == 1) {
					commit('set_vux_case_type2', res.data)
					 
				}
			})
		},
		//选项配置
		get_type_setting({
			commit,
			state
		}, data) {
			
			commit('get_vuex_bom_show', true)

			api('setting', {}, "get").then((res) => {
				 console.log('系统设置', res);
				if (res.code == 1) {
					commit('set_vuex_setting', res.data)
					 
				}

			})
		},
		//选项配置
		get_region_list({
			commit,
			state
		}, data) {
			api('getChinaArea', {
				parent_id:1,
				type:1,
			}, "get").then((res) => {
				console.log('地区设置', res);
				if (res.code == 1) {
					commit('get_vuex_region_list', res.data)
					
				}

			})
		},


		
		 
		 


	},
	modules: {
		// 导出 打印等操作的封装

	},

	plugins: [
		createPersistedState({
			// 存储方式：localStorage、sessionStorage、cookies
			storage: window.localStorage,
			// 存储的 key 的key值
			key: "store",
			render(state) {
				// 要存储的数据：本项目采用es6扩展运算符的方式存储了state中所有的数据
				return {
					...state
				};
			}
		})
	]
});
